module.exports = __webpack_public_path__ + "static/media/covid-vaccine-online.22f8588f.png";